import React, { useEffect, useState } from "react";
import { api } from "../../lib/api";
import { CalendarClock, HandCoins, Wrench, Smartphone, Bell, ShoppingBag, Package } from "lucide-react";

const CARDS = [
  { key: "new_bookings", total: "bookings", label: "Bestillinger", sub: "nye", icon: CalendarClock, color: "bg-electric" },
  { key: "new_sell_requests", total: "sell_requests", label: "Salgsforespørsler", sub: "nye", icon: HandCoins, color: "bg-warm-dark" },
  { key: "new_purchase_requests", total: "purchase_requests", label: "Kjøpsforespørsler", sub: "nye", icon: ShoppingBag, color: "bg-navy" },
  { key: "products", label: "Publiserte produkter", icon: Package, color: "bg-electric" },
  { key: "services", label: "Tjenester", icon: Wrench, color: "bg-navy" },
  { key: "models", label: "Modeller", icon: Smartphone, color: "bg-electric-dark" },
];

export default function Overview() {
  const [data, setData] = useState({});
  useEffect(() => { api.get("/admin/overview").then((r) => setData(r.data)).catch(() => {}); }, []);

  return (
    <div data-testid="admin-overview">
      <h1 className="font-heading text-2xl font-bold text-navy">Oversikt</h1>
      <p className="mt-1 text-sm text-ink/60">Velkommen tilbake. Her er statusen for MobilHub.</p>
      <div className="mt-6 grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-4">
        {CARDS.map((c) => (
          <div key={c.label} className="rounded-xl border border-hairline bg-white p-5 shadow-sm">
            <span className={`flex h-10 w-10 items-center justify-center rounded-lg ${c.color} text-white`}><c.icon className="h-5 w-5" /></span>
            <p className="mt-4 font-heading text-3xl font-bold text-navy">{data[c.total ? c.total : c.key] ?? 0}</p>
            <p className="text-sm text-ink/60">{c.label}</p>
            {c.sub && data[c.key] > 0 && (
              <span className="mt-2 inline-flex items-center gap-1 rounded-full bg-warm/20 px-2 py-0.5 text-xs font-medium text-navy">
                <Bell className="h-3 w-3" /> {data[c.key]} {c.sub}
              </span>
            )}
          </div>
        ))}
      </div>
    </div>
  );
}
